import axios from 'axios';

// In a Capacitor-wrapped native app the webview's own origin is a bare
// localhost/capacitor scheme, not mitifm.com — so the hostname check below
// would otherwise silently point a shipped app at http://localhost:5000.
// window.Capacitor is injected automatically once @capacitor/core runs on
// a native platform, so this check works with no import needed and is a
// no-op (undefined) on the plain web build.
const isNativeApp = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();
const defaultBaseUrl = isNativeApp
    ? 'https://mitifm.com/api'
    : (typeof window !== 'undefined' && window.location.hostname !== 'localhost'
        ? `${window.location.origin}/api`
        : 'http://localhost:5000/api');

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || defaultBaseUrl
});

API.interceptors.request.use(config => {
    const token = localStorage.getItem('fms_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

API.interceptors.response.use(
    res => res,
    err => {
        if (err.response?.status === 401) {
            localStorage.removeItem('fms_token');
            localStorage.removeItem('fms_user');
            window.location.href = '/login';
        }
        return Promise.reject(err);
    }
);

export default API;
